import styled from 'styled-components';

import { colors } from '../../constants';

interface IProps {
    textColor: string;
}

export const PackagePriceDisplay = styled.div<IProps>`
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: ${colors.white};
    color: ${({ textColor }) => textColor};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 700;
`;
